import { Cron } from '@modules/common/types';

export const getReportingFrequencyFromCron = (cron: Cron | undefined) => {
  const cronValue = cron?.valueV2;

  if (cron?.realtime) {
    return 'realtime';
  }

  if (cronValue?.dayOfMonth) {
    return 'monthly';
  }
  // On basis of cron value, daily and weekly can be differentiated as -
  // If dayOfWeek array length is 1 -> Weekly
  // If not, i.e multiple days are selected -> Daily
  if (cronValue?.dayOfWeek && cronValue?.dayOfWeek.length === 1) {
    return 'weekly';
  }

  return 'daily';
};
